import React from "react";
import styles from "./new-alert.module.scss";
import { MdAdd } from "react-icons/md";
interface NewAlertProps {
    handleNewAlert?: any;
}

export const NewAlert: React.FC<NewAlertProps> = ({
    handleNewAlert,
}) => {
    return (
        <div className={styles.container}>
        <div className={styles.box} onClick={handleNewAlert} aria-hidden="true">
            <div className={styles.box__icon}>
                <MdAdd className={styles['box__icon-plus']} size={72} width="100%" height="100%" />
            </div>
            <div className={styles.box__text}>Criar alerta</div>
        </div>
        </div>
    );
};
